import { useContext, useState } from "react";

import { CloudFileListingContext } from "../CloudFileListingContext";
import { CloudFileListingFilters } from "./useCloudFileListingFilters";

export const useCloudFileListing = () => {
    const { items, totalItems, selectedItems, setSelectedItems, reloadData } = useContext(CloudFileListingContext);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getData = async (filters: CloudFileListingFilters): Promise<void> => {
        setIsLoading(true);

        await reloadData(filters);

        setIsLoading(false);
    };

    return {
        items,
        totalItems,
        isLoading,
        getData,
        selectedItems,
        setSelectedItems
    };
};
